import { render, staticRenderFns } from "./instockDetail.vue?vue&type=template&id=08155ee6&scoped=true&"
import script from "./instockDetail.vue?vue&type=script&lang=js&"
export * from "./instockDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08155ee6",
  null
  
)

export default component.exports